"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.common.help': '公共头像对所有用户可见，但非超级管理员无法编辑',
};
